module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADASURBVHgB7ZLtDYJAEET3bEDsgA6kBEuxFDtQKkA7oAQ6sAToADoYxwSi4ev2FvjHS16OwIVZhhPZ0QLgTa+yFfhR0juNZU0wTkYvsgaYZ3l90FGa60M4WVB9sDNbn/sLiLgkdGw9i5+K5jR1zlWDAMUXzoVHve1P+mJQcRA9Tfuibq3pcWLvqbvoVxSPTJa09zUDpPTByZvBU9gpvj+5HXAahJNjg2Na05t3WkOArgZDQFgNygB7DZ6A5TXsWPgAi6kXF4t5NNEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/Images/sendingicon.png
// module id = 1183
// module chunks = 0